import type { DetailedHTMLProps, MetaHTMLAttributes } from 'react';

export function getPageHead(title: string) {
  return {
    meta: [
      {
        title: ['Interchange', title].join(' - '),
      },
    ] as const satisfies (DetailedHTMLProps<MetaHTMLAttributes<HTMLMetaElement>, HTMLMetaElement> | undefined)[],
  };
}
